// extracted by mini-css-extract-plugin
export var text = "premium-tag-module--text--43dc9";
export var wrap = "premium-tag-module--wrap--c52ce";
export var wrapLarge = "premium-tag-module--wrapLarge--57fbf";